<template>
  <div>
    <div class="form-row no-margin">
      <label class="w-100 label-style" for="validationCustom01">{{$t(inputLabel)}}</label>
      <b-input
        :type="inputType"
        :class="[fieldType == 'Percentage'?'percentage-class form-control':'form-control']"
        :id="inputId"
        :placeholder="inputPlaceholder"
        :required="isRequired"
        :value="defaultValue"
        :name="errorMessage"
        v-validate="validation"
        @keyup="onChange($event)"
        @keydown.enter="onChange($event)"
        :disabled="disabled"
        :state="errors.has(errorMessage) ? false : null"
      />
      <span class="d-inline pt-2 ml-2 percentage-symbol" v-if="fieldType == 'Percentage'">%</span>
      <input type="text" hidden style="display:none;">
    </div>
    <div
      :class="'helo-block alert alert-danger errorWidth mt-1'"
      v-show="errors.has(errorMessage)"
    >{{errors.first(errorMessage)}}</div>
  </div>
</template>

<script>
export default {
  props: [
    "inputLabel",
    "inputId",
    "inputPlaceholder",
    "defaultValue",
    "isRequired",
    "errorMessage",
    "inputType",
    "validation",
    "disabled",
    "fieldType"
  ],

  methods: {
    onChange(event) {
      event.preventDefault();
      this.$emit("inputChange", event.target.value);
    }
  }
};
</script>
<style scoped>
.errorWidth {
  font-size: 12px !important;
  width: 100% !important;
  padding: 2px !important;
}
.percentage-class {
  width: 90% !important;
  padding: 2px !important;
}
.percentage-symbol {
  color: #637381 !important;
  font-size: 14px !important;
  width: 6%;
  text-align: center;
}
.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
</style>


